export const AMOUNT_ABBREVIATION = {
  THOUSAND: 'k',
  MILLION: 'm',
  BILLION: 'b',
  TRILLION: 't',
};
